export default "__VITE_ASSET__CfDLoDO8__"